import Vue from 'vue';

export default Vue.component('list-menu-item', {
  template: require('./template.html'),
  name: 'list-menu-item',
  props: ['item', 'display', 'droplet'],
  mounted() {
    if (this.item.modal) {
      const $trigger = $(this.$refs.modalTrigger);
      $trigger.drzModal();
    }
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/list-menu/components/food-item/index.js